module.exports = __webpack_public_path__ + "img/financial-account-export.7f617d51.svg";